import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { setTrackLink } from '@vfit/shared/data-access';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const tagging = getTagging('portability', 'mobile', client);

  const { trackView } = useTracking({
    event: ['checkout_step4.4'],
    event_label: 'migration code',
    opts: tagging?.opts,
    cartProduct: tagging?.trackingProduct,
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackLink(trackView, 'migration code');
  setTrackView(trackView);

  return null;
};

const TaggingPortabilityDataCard = withAnimationDelay()(TaggingComponent);

export default TaggingPortabilityDataCard;
